import { useCallback } from 'react';

import { Tasks } from '@air/api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { type AssetTaggingTask, type GetBaseMetadata } from '~/store/tasks/types';
import { useCreateTask } from '~/utils/taskUtils/useCreateTask';

export type CreatePrivateAssetTaggingTaskParams = GetBaseMetadata<AssetTaggingTask>;

export const useCreatePrivateAssetTaggingTask = () => {
  const { createTask } = useCreateTask();
  const { currentWorkspace } = useCurrentWorkspace();

  const createPrivateAssetTaggingTask = useCallback(
    async ({
      boardId,
      tagIdsToAdd,
      tagIdsToRemove,
      includeDescendants,
      trackLocation,
    }: CreatePrivateAssetTaggingTaskParams) => {
      const workspaceId = currentWorkspace?.id;
      if (!workspaceId) {
        throw new Error('No workspace id');
      }
      const taskArgs = { boardId, tagIdsToAdd, tagIdsToRemove, includeDescendants };
      return createTask({
        task: {
          metadata: {
            boardId,
            tagIdsToAdd,
            tagIdsToRemove,
            includeDescendants,
            trackLocation,
          },
          type: 'AssetTagging',
          workspaceId,
        },
        createTask: () => Tasks.createTask({ workspaceId, task: { type: 'AssetTagger', args: taskArgs } }),
      });
    },
    [createTask, currentWorkspace?.id],
  );

  return {
    createPrivateAssetTaggingTask,
  };
};
